export default __webpack_public_path__ + "static/media/gb-nir.880efdae.svg";